import React, { useEffect, useRef } from "react";
import ParticleBackground from "../components/ParticleBackground";

import PowerBtn from "../components/PowerBtn";
import Footer from "../components/Footer";
import styled from "styled-components";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCode,
  faPalette,
  faUserCheck,
} from "@fortawesome/free-solid-svg-icons";
import { faGithub } from "@fortawesome/free-brands-svg-icons";
import Menu from "../components/Menu";

const Box = styled.div`
  height: 200vh;
  position: relative;
  display: flex;
  align-items: center;
  @media (max-width: 1024px) {
    height: 250vh;
  }
  @media (max-width: 768px) {
    height: 300vh;
  }
`;

const Main = styled(motion.ul)`
  position: fixed;
  top: 20%;
  left: calc(0.5rem + 15vw);
  z-index: 30;
  display: flex;
  color: white;
  @media (max-width: 768px) {
    top: 26%;
    left: calc(3rem + 1vw);
  }
`;

const Card = styled(motion.li)`
  width: 23.5rem;
  height: 55vh;
  background-color: #ffffff;
  color: #000;
  padding: 1rem 2rem;
  margin-right: 2rem;
  border-radius: 0 50px 0 50px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  border: 1px solid #fff;
  transition: all 0.2s ease;

  &:hover {
    background-color: #000000;
    color: #fff;
    border: 1px solid #fff;
  }
  @media (max-width: 768px) {
    height: 54vh;
  }
  @media (max-width: 425px) {
    width: 22.5rem;
    height: 48vh;
  }
`;

const Title = styled.h2`
  font-size: calc(1.5em + 0.5vw);
`;

const Subtitle = styled.div`
  padding-top: 0.1rem;
  border-bottom: 2px solid;
  display: flex;
  flex-wrap: wrap;
  font-size: calc(0.75em + 0.3vw);
`;

const Description2 = styled.div`
  padding-top: 0.5rem;
  font-size: calc(0.75em + 0.3vw);
  display: flex;
  flex-wrap: wrap;
`;
const Image = styled.div`
  background-image: ${(props) => `url(${props.img})`};
  width: 100%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
`;

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,

    transition: {
      staggerChildren: 0.5,
      duration: 0.5,
    },
  },
};

// Framer motion configuration
const Item = {
  hidden: {
    scale: 0,
  },
  show: {
    scale: 1,
    transition: {
      type: "spring",
      duration: 0.5,
    },
  },
};

const Skills = () => {
  const ref = useRef(null);

  useEffect(() => {
    let element = ref.current;

    const rotate = () => {
      element.style.transform = `translateX(${-window.pageYOffset}px)`;
    };

    window.addEventListener("scroll", rotate);
    return () => {
      window.removeEventListener("scroll", rotate);
    };
  }, []);

  return (
    <Box className="z-0">
      <PowerBtn />
      <Menu />

      <Main ref={ref} variants={container} initial="hidden" animate="show">
        <Card variants={Item}>
          <Title className="font-bold">
            Coding Skills <FontAwesomeIcon icon={faCode} />
          </Title>
          <Subtitle className="font-normal text-sm">
            <span className="mb-2 ">
              I value business or brand for which I'm creating, thus I enjoy
              bringing new ideas to life.
            </span>
          </Subtitle>

          <Description2>
            <p className="font-bold text-md">Basic</p>
          </Description2>
          <div className="h-full grid grid-cols-4 gap-2 ">
            <Image
              img={"https://sv1.picz.in.th/images/2022/02/19/r1TKNI.png"}
            />
            <Image
              img={"https://sv1.picz.in.th/images/2022/02/19/r1Ttju.png"}
            />
            <Image
              img={"https://sv1.picz.in.th/images/2022/02/19/r1Tks8.png"}
            />
            <Image
              img={"https://sv1.picz.in.th/images/2022/02/19/r1Tf0q.png"}
            />
            <Image
              img={"https://sv1.picz.in.th/images/2022/02/19/r1TTT0.png"}
            />
            <Image
              img={"https://sv1.picz.in.th/images/2022/02/19/r1T3yR.png"}
            />
            <Image
              img={"https://sv1.picz.in.th/images/2022/02/19/r1Thcz.png"}
            />
            <Image
              img={"https://sv1.picz.in.th/images/2022/02/19/r1TwvZ.png"}
            />
          </div>
          <Description2>
            <p className="font-bold text-md">Tools</p>
          </Description2>
          <div className="grid grid-cols-4 gap-4 ">
            <Image
              img={"https://sv1.picz.in.th/images/2022/02/19/r1TbBQ.png"}
            />
            <Image
              img={"https://sv1.picz.in.th/images/2022/02/19/r1TEvV.png"}
            />

            <div className="flex justify-center items-center">
              <FontAwesomeIcon
                className="text-6xl sm:text-5xl"
                icon={faGithub}
              />
            </div>
          </div>
        </Card>

        <Card variants={Item}>
          <Title className="font-bold">
            Design Skills <FontAwesomeIcon icon={faPalette} />
          </Title>
          <Subtitle className="font-normal text-sm">
            <span className="mb-2 ">
              I love to create design which speaks, Keep it clean, minimal and
              simple.
            </span>
          </Subtitle>

          <Description2>
            <p className="font-bold text-md">Basic</p>
          </Description2>
          <div className="h-full grid grid-cols-4 gap-4 mb-2">
            <Image
              img={"https://sv1.picz.in.th/images/2022/02/19/r1K9iP.png"}
            />
            <Image
              img={"https://sv1.picz.in.th/images/2022/02/19/r1K3SI.png"}
            />
          </div>

          <Description2>
            <p className="font-bold text-md">Intermediate</p>
          </Description2>
          <div className="h-full grid grid-cols-4 gap-4 ">
            <Image
              img={"https://sv1.picz.in.th/images/2022/02/19/r1KQYQ.png"}
            />

            <Image
              img={"https://sv1.picz.in.th/images/2022/02/19/r1KURS.png"}
            />
          </div>
        </Card>

        <Card variants={Item}>
          <Title className="font-bold">
            Personal Skills <FontAwesomeIcon icon={faUserCheck} />
          </Title>
          <Subtitle></Subtitle>

          <Description2>
            <p className="font-bold text-md">COMMUNICATION</p>
            <p>Having strong coordination and good communicator.</p>
            <p className="font-bold text-md">COLLABORATION</p>
            <p>
              Having level of leadership skill and interpersonal skills to work
              effectively with others.
            </p>
            <p className="font-bold text-md">CRITICAL THINKING</p>
            <p>
              Having strong managment, problem analysis and problem solving
              skills.
            </p>
            <p className="font-bold text-md">CREATIVITY</p>
            <p>
              Trying new approaches to get things done, innovation, and
              invention.
            </p>
          </Description2>
        </Card>
      </Main>

      <Footer />
      <ParticleBackground />
    </Box>
  );
};

export default Skills;
